import { SharedState } from '@trello/shared-state';

export type CardHighlighting = 'danger' | 'primary' | 'warning' | undefined;

export interface InboxAssistantCardHighlighting {
  [cardId: string]: CardHighlighting;
}

export const inboxAssistantSharedState = new SharedState<{
  isInboxAssistantOpen: boolean;
  cards: InboxAssistantCardHighlighting;
}>({
  isInboxAssistantOpen: false,
  cards: {},
});
